import { isNullOrUndefinedOrEmpty } from "@/utils/stringHelper.js";
import {RUN_TYPE,INTERVAL_UNIT} from "@/constants/robot.js";

const getIntervalValue = val => {
  return parseInt(val.split("/")[1]);
};
export const defaultCrontable = () => {
  return {
    runType: RUN_TYPE.INTERVAL, //1:interval  2:fixed
    intervalValue: 5,
    intervalUnit: INTERVAL_UNIT.MINUTE, //1:minute 2:hour
    fixedTime: "09:00",
    isIncludingWeekends: false
  };
};
export const analysisCrontable = crontable => {
  const result = defaultCrontable();
  if (isNullOrUndefinedOrEmpty(crontable)) {
    return null;
  }
  const configs = crontable.split(" ");
  if (!configs || configs.length === 0) {
    return null;
  }

  if (crontable.indexOf("/") !== -1) {
    result.runType = RUN_TYPE.INTERVAL;
    if (configs[0].indexOf("/") !== -1) {
      result.intervalUnit = INTERVAL_UNIT.MINUTE;
      result.intervalValue = getIntervalValue(configs[0]);
    } else {
      result.intervalUnit = INTERVAL_UNIT.HOUR;
      result.intervalValue = getIntervalValue(configs[1]);
    }
  } else {
    result.runType = RUN_TYPE.FIXED;
    result.fixedTime = `${("00" + configs[1]).slice(-2)}:${(
      "00" + configs[0]
    ).slice(-2)}`;
    result.isIncludingWeekends = configs[3] === "*";
  }
  return result;
};

export const getDescriptionByCrontable = crontable => {
  let result = "";
  const crontableObject = analysisCrontable(crontable);
  if (crontableObject) {
    if (crontableObject.runType === RUN_TYPE.INTERVAL) {
      result = `每 ${crontableObject.intervalValue} ${
        crontableObject.intervalUnit === INTERVAL_UNIT.MINUTE ? "分钟" : "小时"
      }`;
    } else {
      result = `${crontableObject.isIncludingWeekends ? "每日" : "工作日"} ${
        crontableObject.fixedTime
      }`;
    }
  }
  return result;
};

export const convertObjectToCrontable = crontableObject => {
  const configs = ["*", "*", "*", "*", "*"];
  if (crontableObject) {
    if (crontableObject.runType === RUN_TYPE.INTERVAL) {
      if (crontableObject.intervalUnit === INTERVAL_UNIT.MINUTE) {
        configs[0] = `*/${crontableObject.intervalValue}`;
      } else {
        configs[0] = 0;
        configs[1] = `*/${crontableObject.intervalValue}`;
      }
    } else {
      configs[0] = parseInt(crontableObject.fixedTime.split(":")[1]);
      configs[1] = parseInt(crontableObject.fixedTime.split(":")[0]);
      if (!crontableObject.isIncludingWeekends) {
        configs[3] = "1,2,3,4,5";
      }
    }
  }
  return configs.join(" ");
};
